<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Customer Support</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <div class="tracking-banner">
            <figure>
                <a href="https://www.newgenapps.com/wp-content/uploads/2020/04/Navigator-Navigation-Google-Maps-Map-Location-Gps-2049643.jpg" target="_blank">
                    <img id="t-img" alt="Customer-Support" src="assets/images/customer-service (1).png" width="304" height="328">
                </a>
            </figure>
        </div>
        <form [formGroup]="complainantdropDownForm" (ngSubmit)="goToPage('complain-list')">
            <div>
                <label for="Complainant">Type of Complainant:  </label><br>
                <select formControlName="Complainant">
                    <option>Select Complainant </option>
                    <option *ngFor="let i of Complainant">{{i}}</option>
                </select><br><br>
                <label for="Complainant">Route :  </label><br>
                <select formControlName="Route">
                    <option>Select Route </option>
                    <option *ngFor="let i of Route">{{i}}</option>
                </select><br><br>
                <!-- 
                <div *ngIf="validateFunction.busInfo.touched && validateFunction.busInfo.invalid">
                    <div *ngIf="validateFunction.busInfo.errors.required">Name is required.</div>
                </div> -->

            </div>
            <button type="submit" [disabled]="!complainantdropDownForm.valid">Submit</button>
        </form>
    </div>
</div>